export const modules = {
  dateShort: require('./date-short').default,
  dateFormat: require('./date-format').default,
  date: require('./date').default,
  money: require('./money').default,
  tagStatus: require('./tag-status').default,
  tagStatus2: require('./tag-status2').default,
  tagBank: require('./tag-bank').default,
  percent: require('./percent').default,
  truncate: require('./text-truncate').default,
  filterCompany: require('./filter-company').default,
  dateRange: require('./date-range').default,
  boolIcon: require('./bool-icon').default,
  search: require('./search').default,
  digit: require('./digit').default,
  longText: require('./long-text').default,
  capitalize: require('./capitalize').default
}
